export default "__VITE_ASSET__DYw4bP9O__"